module.exports = __webpack_public_path__ + "media/images/openweather/mapicons/de-7938e9a05c33a74967051197b6b9d67f.png";